var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentoring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mentoring"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 29.333L13.3333 21.333H2.66663L5.33329 29.333H16ZM16 29.333H21.3333",
    stroke: "#005F89",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 17.333V16.6663C16 14.1522 16 12.8951 15.219 12.1141C14.4379 11.333 13.1809 11.333 10.6667 11.333C8.15255 11.333 6.89547 11.333 6.11443 12.1141C5.33337 12.8951 5.33337 14.1522 5.33337 16.6663V17.333",
    stroke: "#005F89",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.3333 17.3337C25.3333 18.8065 24.1395 20.0003 22.6667 20.0003C21.1939 20.0003 20 18.8065 20 17.3337C20 15.8609 21.1939 14.667 22.6667 14.667C24.1395 14.667 25.3333 15.8609 25.3333 17.3337Z",
    stroke: "#005F89",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.3333 5.33366C13.3333 6.80642 12.1394 8.00033 10.6667 8.00033C9.19391 8.00033 8 6.80642 8 5.33366C8 3.8609 9.19391 2.66699 10.6667 2.66699C12.1394 2.66699 13.3333 3.8609 13.3333 5.33366Z",
    stroke: "#005F89",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.6666 23.333H26.6666C28.1394 23.333 29.3333 24.5269 29.3333 25.9997V26.6663C29.3333 28.1391 28.1394 29.333 26.6666 29.333H25.3333",
    stroke: "#005F89",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentoring);
export default __webpack_public_path__ + "static/media/mentoring.8f7252a68d6e83a2e1405a0eabb221a2.svg";
export { ForwardRef as ReactComponent };